import React, { ReactElement } from 'react';
import classNames from 'classnames';

import logos from './partners.data';
import Link from 'atomic/link/link';

export const partnersLinks = (blockClassName: string): ReactElement[] => {
    const listItems = logos.map(item => {
        const rel = item.doFolow ? undefined : 'nofollow';

        return (
            <Link
                href={item.url}
                target="_blank"
                rel={rel}
                wrapper={true}
                className={classNames({
                    [`${blockClassName}__list-item`]: true
                })}
                key={item.url}
            >
                <img src={item.image} alt={item.title} className={`${blockClassName}__image`}
                    loading="lazy"
                />
            </Link>
        );
    });

    return listItems;
};
